/*------------------------------------*\
    MODULES
\*------------------------------------*/
import ModalVideo from 'modal-video';

/*------------------------------------*\
    VIDEO MODAL
\*------------------------------------*/
class VideoModal {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.id = self.elem.getAttribute('id');
        self.source = self.elem.getAttribute('data-video-source');
    }

    init() {
        let self = this;

        new ModalVideo(`#${self.id}`, {channel: self.source});
    }
}

export default VideoModal;